// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"71c68ff8","579":"cd819385","734":"c8b95522"}[chunkId] + ".chunk.js";
};